import { render } from "./photo-dispute.vue?vue&type=template&id=0fed95a3&scoped=true&ts=true"
import script from "./photo-dispute.vue?vue&type=script&lang=ts"
export * from "./photo-dispute.vue?vue&type=script&lang=ts"

import "./photo-dispute.vue?vue&type=style&index=0&id=0fed95a3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fed95a3"]])

export default __exports__